import { useState } from 'react'
import { t } from 'i18next'
import { IFormModel } from 'types'

/**
 * Form constants
 */
const SEARCH = 'search'
const CREATOR = 'creator'
const START_DATE_FROM = 'start_date_from'
const START_DATE_TO = 'start_date_to'
const STATUS = 'status'
const STUDENT = 'student'
const CATEGORY = 'category'

/**
 * Form model
 */
const formModel = (): IFormModel  => {
  return {
    [SEARCH]: {
      label: `${t('common.search-table')}`,
      name: SEARCH,
    },
    [CREATOR]: {
      label: `${t('common.creator')}`,
      name: CREATOR,
    },
    [START_DATE_FROM]: {
      label: `${t('common.from')}`,
      name: START_DATE_FROM,
    },
    [START_DATE_TO]: {
      label: `${t('common.to')}`,
      name: START_DATE_TO,
    },
    [STATUS]: {
      label: `${t('common.status')}`,
      name: STATUS,
    },
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
    },
    [CATEGORY]: {
      label: `${t('common.category')}`,
      name: CATEGORY,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SEARCH]: '',
  [CREATOR]: null, 
  [START_DATE_FROM]: null,
  [START_DATE_TO]: null,
  [STATUS]: null,
  [STUDENT]: null,
  [CATEGORY]: null
}

/**
 * Form state
 */
export const useParams = () => {
  const [params, setParams] = useState(initialValues)

  return { params, setParams }
}

export default formModel
